global.ThemeName = 'default-theme';

require('./app.js');
